/* RELIV Studio — scroll reveal + hero route draw.
   Loaded with `defer` from the head so the whole document is parsed first.
   The previous inline version ran mid-page and only ever saw the hero's
   .rise elements, leaving everything below stuck at opacity:0. */
(function () {
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(el) {
    el.classList.add('in');
  }

  function bindRise(scope) {
    var els = (scope || document).querySelectorAll('.reliv .rise:not(.in)');
    if (!els.length) return;

    if (REDUCE || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, reveal);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          reveal(en.target);
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    Array.prototype.forEach.call(els, function (e, i) {
      e.style.transitionDelay = Math.min(i % 3, 2) * 90 + 'ms';
      io.observe(e);
    });

    /* Safety net. Horizon scrolls a nested .page-wrapper rather than the
       document, and some browsers/embeds never deliver an intersection for
       offscreen nodes in that setup. If an element is still hidden but has
       been scrolled past, force it visible. Never leave content invisible. */
    var ticks = 0;
    var sweep = setInterval(function () {
      var left = document.querySelectorAll('.reliv .rise:not(.in)');
      if (!left.length || ++ticks > 40) { clearInterval(sweep); }
      Array.prototype.forEach.call(left, function (e) {
        var r = e.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.94 && r.bottom > 0) {
          io.unobserve(e);
          e.style.transitionDelay = '0ms';
          reveal(e);
        }
      });
    }, 250);
  }

  /* ---- Relief build animation -------------------------------------------
     Every relief disc is an inline SVG whose terrain is a stack of stroked
     contour paths in document order, low ground first. We give each contour
     an index and its own path length, then CSS draws them on one at a time
     and runs the route line once the terrain has finished. The disc, the
     brass ring and the gradient are untouched, so the piece never appears
     broken mid-animation.

     Each contour carries its own `opacity` attribute (0.43 -> 0.91 is the
     usual range). That value is copied to --o so the fade-in lands on the
     artwork's real opacity instead of blowing every band out to full. */
  function prepRelief(svg, opts) {
    if (!svg || svg.dataset.relivRelief === '1') return null;
    svg.dataset.relivRelief = '1';

    var paths = svg.querySelectorAll('path:not(.route):not(.route-casing)');
    var n = 0;
    Array.prototype.forEach.call(paths, function (p) {
      p.classList.add('c');
      p.style.setProperty('--i', n);

      var o = p.getAttribute('opacity');
      if (o) p.style.setProperty('--o', o);

      /* A path can only "draw" if it has a stroke. The handful of very low
         opacity fill washes in the tier artwork fade instead. */
      var stroke = p.getAttribute('stroke');
      var len = 0;
      if (stroke && stroke !== 'none' && p.getTotalLength) {
        try { len = Math.ceil(p.getTotalLength()) + 2; } catch (e) { len = 0; }
      }
      if (len) { p.style.setProperty('--len', len); }
      else { p.classList.add('f'); }
      n++;
    });

    var step = opts.step;
    var contourDur = opts.contourDur;
    var routeDur = opts.routeDur;
    var contourEnd = (n * step) + contourDur;

    svg.style.setProperty('--step', step + 'ms');
    svg.style.setProperty('--contour-dur', contourDur + 'ms');
    svg.style.setProperty('--route-dur', routeDur + 'ms');
    svg.style.setProperty('--route-start', (contourEnd + 130) + 'ms');

    var route = svg.querySelector('.route');
    var len = 0;
    if (route && route.getTotalLength) {
      try { len = Math.ceil(route.getTotalLength()) + 4; } catch (e) { len = 0; }
    }
    if (len) {
      svg.querySelectorAll('.route, .route-casing').forEach(function (el) {
        el.style.setProperty('--len', len);
      });
    } else {
      /* No measurable route: skip the draw rather than hide the line. */
      svg.classList.add('no-route-draw');
    }
    return svg;
  }

  function playRelief(svg) {
    if (!svg || svg.dataset.relivPlayed === '1') return;
    svg.dataset.relivPlayed = '1';
    requestAnimationFrame(function () { svg.classList.add('go'); });
  }

  /* Reduced motion, or a browser without getTotalLength: show the finished
     piece immediately. The artwork must never be left invisible. */
  function settleRelief(svg) {
    svg.dataset.relivRelief = '1';
    svg.dataset.relivPlayed = '1';
    svg.classList.add('settled');
  }

  /* The tier art ships as <img src="...svg">, which cannot be animated —
     the paths live in a separate document. Liquid's inline_asset_content
     refuses these files (they are past its size cap and it silently emits
     a comment instead), so we pull each one down and swap it for real
     inline SVG. The cards sit below the fold and start hidden behind the
     .rise reveal, so the swap is never on screen. If a fetch fails the
     original <img> is left exactly where it was and the card still shows
     its art, just without the build. */
  function inlineArtifact(img, done) {
    var src = img.getAttribute('src');
    if (!src || !window.fetch || !window.DOMParser) { done(); return; }
    fetch(src, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (txt) {
        var doc = new DOMParser().parseFromString(txt, 'image/svg+xml');
        var srcSvg = doc.documentElement;
        if (!srcSvg || String(srcSvg.nodeName).toLowerCase() !== 'svg' ||
            doc.getElementsByTagName('parsererror').length) { done(); return; }
        var svg = document.importNode(srcSvg, true);
        svg.setAttribute('class', img.getAttribute('class') || 'artifact');
        svg.setAttribute('role', 'img');
        var alt = img.getAttribute('alt');
        if (alt) svg.setAttribute('aria-label', alt);
        /* Let the stylesheet size it, exactly as it sized the <img>. */
        svg.removeAttribute('width');
        svg.removeAttribute('height');
        if (img.parentNode) img.parentNode.replaceChild(svg, img);
        done();
      })
      .catch(function () { done(); });
  }

  function buildReliefs(scope) {
    var root = scope || document;
    var imgs = Array.prototype.slice.call(
      (root.querySelectorAll ? root.querySelectorAll('.reliv img.artifact') : [])
    );

    /* Wire whatever is already inline (the hero) straight away rather than
       making it wait on the tier downloads. wireReliefs is idempotent. */
    wireReliefs(root);
    if (!imgs.length) return;

    var pending = imgs.length;
    imgs.forEach(function (img) {
      inlineArtifact(img, function () {
        if (--pending === 0) wireReliefs(root);
      });
    });
  }

  function wireReliefs(scope) {
    var root = scope || document;
    var heroArt = root.querySelector ? root.querySelector('#relivHeroArt .artifact') : null;

    /* The hero is the showpiece and runs a touch slower. Tier cards are
       scrolled past, so they build faster and finish in about three seconds. */
    var all = root.querySelectorAll('.reliv svg.artifact');
    Array.prototype.forEach.call(all, function (svg) {
      if (svg.dataset.relivRelief === '1') return;
      if (REDUCE) { settleRelief(svg); return; }

      var isHero = (svg === heroArt) || !!svg.closest('#relivHeroArt');
      var opts = isHero
        ? { step: 22, contourDur: 1050, routeDur: 1600 }
        : { step: 16, contourDur: 900,  routeDur: 1400 };

      prepRelief(svg, opts);

      /* Above the fold: run on load. Below: run when it comes into view. */
      if (isHero || !('IntersectionObserver' in window)) {
        playRelief(svg);
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            playRelief(en.target);
            io.unobserve(en.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.3 });
      io.observe(svg);

      /* Same safety net as the .rise reveal: Horizon scrolls a nested
         wrapper and can fail to deliver an intersection. Never leave a
         relief stuck at opacity 0. */
      var ticks = 0;
      var sweep = setInterval(function () {
        if (svg.dataset.relivPlayed === '1' || ++ticks > 40) {
          clearInterval(sweep);
          return;
        }
        var r = svg.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.95 && r.bottom > 0) {
          io.unobserve(svg);
          playRelief(svg);
          clearInterval(sweep);
        }
      }, 250);
    });
  }



  /* Long-form pages (How It Works, About, the policy pages) come through
     Horizon's stock page template as one run of h2/p in a single ink colour.
     Two presentational passes add the brass the rest of the site already uses
     without touching a word of the copy in the admin:

       1. A leading "1." / "2." in a heading is wrapped so the numeral can take
          the brass the homepage step numbers use.
       2. A paragraph short enough to be a pull-line is marked so it can be set
          in brass instead of body ink.

     Both are additive. If Aaron retypes a heading in the admin the markup is
     rebuilt on the next load, and if this script never runs the page still
     reads correctly in plain bone. */
  function markPageProse() {
    var body = document.querySelector('.page-content');
    if (!body || body.dataset.relivProse === '1') return;
    body.dataset.relivProse = '1';

    body.querySelectorAll('h2, h3').forEach(function (h) {
      if (h.querySelector('.reliv-n')) return;
      var first = h.firstChild;
      if (!first || first.nodeType !== 3) return;
      var m = first.nodeValue.match(/^\s*(\d+[.)])\s+/);
      if (!m) return;
      var span = document.createElement('span');
      span.className = 'reliv-n';
      span.textContent = m[1];
      first.nodeValue = first.nodeValue.slice(m[0].length);
      h.insertBefore(span, h.firstChild);
      h.classList.add('has-n');
    });

    body.querySelectorAll('p').forEach(function (p) {
      var t = (p.textContent || '').trim();
      if (!t || t.length > 68) return;
      if (p.querySelector('a, img')) return;
      /* One sentence, no list, standing on its own line. */
      if ((t.match(/[.?!]/g) || []).length > 1) return;
      p.classList.add('reliv-pull');
    });
  }

  function start() {
    bindRise(document);
    buildReliefs(document);
    markPageProse();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Theme editor: sections are swapped in after load. */
  document.addEventListener('shopify:section:load', function (e) {
    bindRise(e.target);
    buildReliefs(e.target);
    markPageProse();
  });
})();
